export default __webpack_public_path__ + "static/media/shogun_001.91512043.jpg";